import * as React from 'react';

const AddIcon = (props) => (
  <svg
    width='21'
    height='22'
    viewBox='0 0 21 22'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clip-path='url(#clip0_15_39)'>
      <path
        d='M10.5 0C4.70995 0 0 4.93423 0 11C0 17.0658 4.70995 22 10.5 22C16.2901 22 21 17.0649 21 11C21 4.93509 16.2901 0 10.5 0ZM10.5 20.2959C5.60786 20.2959 1.62664 16.126 1.62664 11C1.62664 5.87404 5.60786 1.7041 10.5 1.7041C15.3921 1.7041 19.3734 5.87404 19.3734 11C19.3734 16.126 15.393 20.2959 10.5 20.2959Z'
        fill={props.color}
      />
      <path
        d='M14.5666 10.0713H11.3133V6.66307C11.3133 6.19274 10.9497 5.811 10.5 5.811C10.0502 5.811 9.68661 6.19274 9.68661 6.66307V10.0713H6.43334C5.98356 10.0713 5.62 10.453 5.62 10.9233C5.62 11.3937 5.98356 11.7754 6.43334 11.7754H9.68661V15.1836C9.68661 15.6539 10.0502 16.0357 10.5 16.0357C10.9497 16.0357 11.3133 15.6539 11.3133 15.1836V11.7754H14.5666C15.0163 11.7754 15.3799 11.3937 15.3799 10.9233C15.3799 10.453 15.0163 10.0713 14.5666 10.0713Z'
        fill={props.color}
      />
    </g>
    <defs>
      <clipPath id='clip0_15_39'>
        <rect width='21' height='22' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
export default AddIcon;
